<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />
  <p-card>
    <ng-template #title>
      <h1>{{ 'catalog.products.title' | translate }}</h1>
    </ng-template>

    <div class="flex justify-end gap-2 mb-5">
      <p-button
        icon="fa fa-plus"
        [label]="'catalog.products.add' | translate"
        (onClick)="navigateToCreate()"
      />
    </div>

    <p-table
      [value]="service.items()"
      stripedRows
      showGridlines
      dataKey="id"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      [scrollable]="true"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template #header>
        <tr>
          <th>{{ 'catalog.products.fields.titleDe' | translate }}</th>
          <th>{{ 'catalog.products.fields.key' | translate }}</th>
          <th>{{ 'catalog.products.fields.category' | translate }}</th>
          <th>{{ 'catalog.products.fields.active' | translate }}</th>
          <th class="text-right">
            {{ 'catalog.products.displayPrice' | translate }}
          </th>
          <th pFrozenColumn alignFrozen="right" class="w-32"></th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr class="cursor-pointer" (click)="navigateToDetail(row)">
          <td>{{ productTitle(row) }}</td>
          <td>
            <code class="text-xs">{{ row.key }}</code>
          </td>
          <td>{{ categoryTitle(row.category_id) }}</td>
          <td>
            @if (row.active) {
              <p-tag severity="success" value="✓" />
            } @else {
              <p-tag severity="secondary" value="—" />
            }
          </td>
          <td class="text-right">{{ formatDisplayPrice(row) }}</td>
          <td pFrozenColumn alignFrozen="right">
            <div class="flex items-center justify-end gap-2">
              <button
                pButton
                type="button"
                icon="fa fa-pencil"
                text
                rounded
                severity="secondary"
                (click)="navigateToDetail(row); $event.stopPropagation()"
              ></button>
              <button
                pButton
                type="button"
                icon="fa fa-trash"
                text
                rounded
                severity="secondary"
                (click)="onRowDelete($event, row); $event.stopPropagation()"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="6" class="text-center italic text-color-secondary py-6">
            {{ 'catalog.products.empty' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
